import { render, staticRenderFns } from "./InstitutionAccountState.vue?vue&type=template&id=7e4f4870&"
import script from "./InstitutionAccountState.vue?vue&type=script&lang=ts&"
export * from "./InstitutionAccountState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports